import { useMediaQuery, useTheme } from "@mui/material";
import CardMobile from "./SchwarzesBrettCard/CardMobile";
import CardDesktop from "./SchwarzesBrettCard/CardDektop";

export default function SchwarzesBrettCard({ item, openDatei, openDetails, filter, user, startDelete }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {isMobile ? (
        <CardMobile item={item} openDatei={openDatei} openDetails={openDetails} filter={filter} user={user} startDelete={startDelete} />
      ) : (
        <CardDesktop item={item} openDatei={openDatei} openDetails={openDetails} filter={filter} user={user} startDelete={startDelete} />
      )}
    </>
  );
}
